import React from 'react'
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './common/main/Layout';
import SignUp from './Pages/signup/SignUp';
import User from './Pages/user/User';
import Vehicles from './Pages/vehicles/Vehicles';
import Spots from './Pages/lookingspots/Spots';
// import GivingSpots from './Pages/spotseeker/SpotSeekers';
// import Snags from './Pages/snags/Snags';
import FeedBack from './Pages/feedback/FeedBack';
import SupportTicket from './Pages/supportTicket/SupportTicket';
import EmailVerify from './Pages/forgot/EmailVerify';
import SpotSeekers from './Pages/spotseeker/SpotSeekers';
import ChangePassword from './Pages/changePassword/ChangePassword';
function App() {
  return (
    <div className="App">
    <ToastContainer />
     <Router>
        <Routes>
          <Route path="/" element={<SignUp/>} />
          {/* <Route path="/forgot" element={<EmailVerify/>} /> */}
          {/* <Route path="/users" element={Layout(Dashboard)()}/> */}
           <Route path="/users" element={Layout(User)()}/>

            <Route path="/vehicles" element={Layout(Vehicles)()} />
            <Route path="/spot-givers" element={Layout(Spots)()} />
            <Route path="/spot-seekers" element={Layout(SpotSeekers)()} />
            {/* <Route path="/snags" element={Layout(Snags)()} /> */}
            <Route path="/feedbacks" element={Layout(FeedBack)()} />
            <Route path="/support-tickets" element={Layout(SupportTicket)()} />
            <Route path="/change-password" element={Layout(ChangePassword)()} />



        </Routes>
        </Router>

</div>
  );
}

export default App;
